<template>
    <div>
        <div class="card-body"> 
            <div class="col-md-12 pl-5 pr-5" style="height: 300px;overflow-y: auto;">
                <v-radio-group v-model="VoteId">
                    <v-radio :label="item.text" v-for="item in VotesList" :key="item.id" :value="item.id"></v-radio>
                </v-radio-group>
            </div>
        </div>
        <div>
            <v-card-actions class="gap-2 sticky-actions" style="border-radius: 0 0 30px 30px;padding: 0.7rem !important;">
                <v-spacer></v-spacer>
                <v-btn class="light-blue btn-sm" style="min-width: 80px !important" @click="cancelDialog">{{$t("res_ButtonText_Cancel")}}</v-btn>
                <v-btn class="primary btn-sm"  style="min-width: 80px !important" :disabled="!validForm" @click="castVote">{{$t("res_ButtonText_Continue")}}</v-btn>
            </v-card-actions>
        </div>
    </div>
</template>

<script>
    import constants from '@/assets/js/constants'
    import axios from 'axios'

	export default {
		name: 'Vote',
		data() {
            return {
                pinValue: '',
                validForm: false,
                canSignByImpersonation:false,
                SignAsOptions: [{ label: 'On behalf', value: false }, { label: 'Impersonation', value: true}],
                SelectedSignAsOption: false ,
                constants:constants,
                search_query:"",
                Workflow_items:null,
                VoteId:0,
                VotesList:[]
            };
        },
        props: { 
            selectedLang: { type: String, required: false },
            documentId: { type: Number, required: false },
            transferId: { type: Number, required: false },
            delegationId: { type: Number, required: false },
            dialogModelShow: { type: Boolean, default: false },
            workflowId: { type: Number, default: 0 },
        },
        methods:
        {
            cancelDialog()
            {
                this.$emit('closeVoteFormDialog');
            },
            submitVoting()
            {
                this.$emit('submitVoting');
            },
            resetForm()
            {
                this.pinValue = ''
                this.validForm = false
                this.canSignByImpersonation=false
                this.SelectedSignAsOption= false
            },
            getAllWorkFlowVotes(){
                axios
					.get(
						constants.baseApiUrl +
							`Workflow/GetAllWorkFlowVotes?workflowId=${this.workflowId}&lang=${this.selectedLang}`
					)
					.then((res) => { 
                        this.VotesList = res.data
                        console.log('workflow votes = ', res.data)
					})
					.catch((err) => console.warn(err));
            },
            castVote(){
                axios
					.post(
						constants.baseApiUrl +
							`Workflow/CastVote?voteId=${this.VoteId}&transferId=${this.transferId}&documentId=${this.documentId}`
					)
					.then((res) => { 
                         this.submitVoting(); 
					})
					.catch((err) => console.warn(err));
            } 
        },
        watch:
        {
            dialogModelShow(newVal, oldVal)
            {
                if (newVal != oldVal && newVal == false)
                { 
                    this.resetForm();
                }
            },
            VoteId(newVal, oldVal)
            {
                if (newVal != oldVal)
                {
                    if (newVal>0)
                    {
                        this.validForm=true
                       
                    }
                }
            },
        },
        mounted: function ()
        {
            this.getAllWorkFlowVotes();
        }
	}
</script>
<style>
.v-radio .v-label{
    top:3px !important
}
</style>